import $ from 'jquery';
import Menu from './menu';
import Search from './search';
import Carousel from './carousel';
import Gallery from './gallery';
import Video from './video';
import Youtube from './youtube';
import PrintButton from './print-button';
import Tabs from './tabs';
import TranslationMenu from './translation-menu';
import GotoUpcomingSeminars from './goto-upcoming-seminars';
import FileTracking from './file-tracking';
import Alert from './alert';
import IframeLoader from './iframe-loader';

$(() => {
    const jsMenu = $('.js-toggle-menu');
    if (jsMenu.length) {
        [...jsMenu].map((e) => Menu(e))
    }

    const jsSearch = $('#search-desktop');
    if (jsSearch.length) {
        [...jsSearch].map((e) => Search(e))
    }

    const jsCarousel = $('.js-carousel');
    if (jsCarousel.length) {
        [...jsCarousel].map((e) => Carousel(e))
    }

    const jsGallery = $('.js-gallery');
    if (jsGallery.length) {
        [...jsGallery].map((e) => Gallery(e))
    }

    const jsVideo = $('.js-play');
    if (jsVideo.length) {
        [...jsVideo].map((e) => Video(e))
    }

    const jsYoutube = $('.js-youtube');
    if (jsYoutube.length) {
        [...jsYoutube].map((e) => Youtube(e))
    }

    const $jsPrintButton = $('.js-print-button');
    if ($jsPrintButton.length) {
        $jsPrintButton.map((_, el) =>
            PrintButton(el)
        );
    }

    const jsTabs = $('.js-tabs');
    if (jsTabs.length) {
        [...jsTabs].map((e) => Tabs(e))
    }

    const jsTranslationMenu = $('.js-translation-menu');
    if (jsTranslationMenu.length) {
        [...jsTranslationMenu].map((e) => TranslationMenu(e))
    }

    const jsGotoUpcomgingSeminars = $('.js-goto-upcoming-seminars');
    if (jsGotoUpcomgingSeminars.length) {
        [...jsGotoUpcomgingSeminars].map((e) => GotoUpcomingSeminars(e))
    }

    const jsPdfFiles = $('a[href$=".pdf"]');
    if (jsPdfFiles.length) {
        FileTracking();
    }

    const jsAlert = $('.js-alert');
    if (jsAlert.length) {
        [...jsAlert].map((e) => Alert(e))
    }

    const jsIframeLoader = $('.js-iframe-loader');
    if (jsIframeLoader.length) {
        [...jsIframeLoader].map((e) => IframeLoader(e))
    }
});
